<div [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>
<ngx-spinner><span class="title text-white">Loading...</span></ngx-spinner>
<ng-template #dialogTemplate let-dialogRef="dialogRef" let-data>
    <div class="custom-dialog-container">
        <h1 mat-dialog-title class="dialog-title">{{ data.title }}</h1>
        <hr>
        <p [innerHTML]="data.description"></p>
        <p *ngIf="data.link">
            <a href="{{ data.link }}">Click here to know more!</a>
        </p>
        <hr>
        <button mat-button class="custom-button" (click)="dialogRef.close('Ok')">Got It</button>
    </div>
</ng-template>